import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonGroup = () => {
    return (
        <div>
            <div className='user__item relative flex gap-[10px] mx-[10px] py-[8px] '>
                <div>
                    <Skeleton
                        circle={true}
                        width={32}
                        height={32}
                        duration={1}
                    />
                </div>
                <div className='w-full'>
                    <div className='content__wrapper'>
                        <span>
                            <Skeleton width={170} height={15} duration={2} />
                        </span>
                        <div className='__content '>
                            <Skeleton width='100%' height={40} duration={1} />
                        </div>
                        <div className='__actions flex gap-[10px] text-[#999]'>
                            <Skeleton width={40} height={15} duration={2} />
                            <Skeleton width={40} height={15} duration={2} />
                            <Skeleton width={40} height={15} duration={2} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonGroup;
